export default __webpack_public_path__ + "static/media/partnerstack-logo-vector-condensed.01be735e.svg";